export type PublicEnvironment = {
  supabaseUrl: string;
  supabasePublishableKey: string;
};

type EnvironmentSource = Record<string, string | boolean | undefined>;

export type EnvironmentResult =
  | { ok: true; value: PublicEnvironment }
  | { ok: false; message: string };

export function readPublicEnvironment(source: EnvironmentSource = import.meta.env): EnvironmentResult {
  const supabaseUrl = source.VITE_SUPABASE_URL;
  const supabasePublishableKey = source.VITE_SUPABASE_PUBLISHABLE_KEY;

  const missing = [
    !supabaseUrl && "VITE_SUPABASE_URL",
    !supabasePublishableKey && "VITE_SUPABASE_PUBLISHABLE_KEY",
  ].filter(Boolean);

  if (missing.length > 0) {
    return {
      ok: false,
      message: `Missing browser-safe environment values: ${missing.join(", ")}`,
    };
  }

  try {
    const url = new URL(String(supabaseUrl));
    if (url.protocol !== "https:" && url.hostname !== "127.0.0.1" && url.hostname !== "localhost") {
      return { ok: false, message: "VITE_SUPABASE_URL must use HTTPS outside local development." };
    }
  } catch {
    return { ok: false, message: "VITE_SUPABASE_URL is not a valid URL." };
  }

  return {
    ok: true,
    value: {
      supabaseUrl: String(supabaseUrl),
      supabasePublishableKey: String(supabasePublishableKey),
    },
  };
}
